import { type FC, type HTMLAttributes } from 'react'
import { useIntl } from 'react-intl'
import { Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import Loader, { type LoaderProps } from '@DS/components/components/loaders/loader/Loader'

import * as styles from './styles'

type LoadingProps = {
  isLoading: boolean
  loadingPadding?: number
  message?: string
  spacing?: number
} & LoaderProps

// TODO: à supprimer quand on aura une gestion de loader globale
const Loading: FC<LoadingProps & HTMLAttributes<HTMLDivElement>> = ({
  children,
  isLoading,
  loadingPadding = 10,
  message,
  size = 60,
  spacing = 2,
  'aria-label': ariaLabel,
}) => {
  const theme = useTheme()
  const { formatMessage } = useIntl()
  const loaderMessage =
    message ??
    formatMessage({
      id: 'loading',
    })

  return (
    <>
      {isLoading ? (
        <Stack
          css={styles.loading(theme, loadingPadding)}
          spacing={spacing}
          role="status"
          aria-live="polite"
          aria-label={ariaLabel ?? loaderMessage}
        >
          <Typography component="p" variant="h3">
            {loaderMessage}
          </Typography>

          <Loader size={size} />
        </Stack>
      ) : (
        children
      )}
    </>
  )
}

export default Loading
